import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "order-form-main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "pageRemoveModal"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ページ遷移すると編集中の情報は破棄されます。よろしいですか？"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※前のステップに戻りたい場合は、ページ下部のリンクから遷移してください。 ")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-button-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_steps = _resolveComponent("order-steps")!
  const _component_select_plan = _resolveComponent("select-plan")!
  const _component_customer_info = _resolveComponent("customer-info")!
  const _component_check_order = _resolveComponent("check-order")!
  const _component_ButtonForward = _resolveComponent("ButtonForward")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_order_steps, { "current-step": _ctx.orderStep }, null, 8, ["current-step"]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_select_plan, {
          "area-list": _ctx.formInputOptions.areaList,
          "prefecture-list": _ctx.computedPrefectureLists,
          "country-list": _ctx.formInputOptions.countryList,
          onForwardToCustomerProfile: _ctx.onForwardToCustomerProfile
        }, null, 8, ["area-list", "prefecture-list", "country-list", "onForwardToCustomerProfile"])
      ], 512), [
        [_vShow, _ctx.orderStep === 1]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_customer_info, {
          "prefecture-list": _ctx.computedPrefectureLists,
          "select-plan-form-data": _ctx.selectPlanFormData,
          csvOptions: _ctx.csvOptions,
          onBackToSelectPlan: _ctx.onBackToSelectPlan,
          onForwardToCheckOrder: _ctx.onForwardToCheckOrder
        }, null, 8, ["prefecture-list", "select-plan-form-data", "csvOptions", "onBackToSelectPlan", "onForwardToCheckOrder"])
      ], 512), [
        [_vShow, _ctx.orderStep === 2]
      ]),
      (_ctx.orderStep === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_check_order, {
              "select-plan-data": _ctx.selectPlanFormData,
              "customer-info-data": _ctx.customerInfoFormData,
              csvOptions: _ctx.csvOptions,
              "customer-info-status": _ctx.customerInfoFormStatus,
              "estimation-data": _ctx.selectPlanFormStatus.estimationData,
              prefectures: _ctx.formInputOptions.shireList,
              onBackToCustomerInfo: _ctx.onBackToCustomerInfo
            }, null, 8, ["select-plan-data", "customer-info-data", "csvOptions", "customer-info-status", "estimation-data", "prefectures", "onBackToCustomerInfo"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CommonModal, {
      "is-show": _ctx.isShowPageRemoveAlert,
      "onUpdate:isShow": _ctx.cancelPageRemove
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _hoisted_5, 512),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ButtonForward, {
            title: "情報を破棄して遷移する",
            onClick: _ctx.pageRemove
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["is-show", "onUpdate:isShow"])
  ], 64))
}